<template>

	<div>

		<!-- content -->
		<div class="content learning">
			<div class="container">

				<edu-learning v-if="mode === 'learn' && emIdx > 0" @goList="goList"></edu-learning>


				<template v-if="mode === '' || mode === 'list' ">
					<!-- 페이지 타이틀 -->
					<div class="page-title">
						<h2 class="tit">{{ titleCodeVO.codeName }}</h2>
					</div>
					<!-- 리스트 옵션 -->
					<div class="list-controls">

						<!-- 탭 -->
						<div class="tab swiper-container">
							<ul class="swiper-wrapper">
								<li class="swiper-slide">
									<a :href="'/app/education/course/' + $route.params.cateCode">교육과정</a>
								</li>
								<li class="active swiper-slide">
									<a :href="'/app/education/main/' + $route.params.cateCode">교육과목</a>
								</li>
							</ul>
						</div>

						<form @submit.prevent="doSearch">

							<code-tree-selector v-if="!$options.filters.isEmpty($route.params.cateCode)" :base-code="$route.params.cateCode" :old-code="this.$route.query.cateCode" @selectCode="setCateCode"></code-tree-selector>

							<div class="search">
								<p class="total">총 <span>{{ eduCount }}</span>개의 게시물이 있습니다.</p>
								<div class="search-form">
									<input class="inp-search" id="" name="" type="text" placeholder="검색어를 입력하세요" v-model="params.searchText">
									<button type="submit" class="btn-search"></button>
								</div>
							</div>
						</form>

						<edu-sorter @doSort="doSort"></edu-sorter>

					</div>

					<edu-list :edu-list="eduList"></edu-list>

					<!-- 버튼 -->
					<div class="btn-area" v-if="eduList.length < eduCount">
						<a href="javascript:;" class="btn-loadmore" @click="doLoadMore">LOAD MORE</a>
					</div>

				</template>

			</div>
		</div>
		<!--//content -->

	</div>

</template>

<script>
import $ from 'jquery'
import EduList from "@/components/educations/main/eduList";
import EduLearning from "@/components/educations/main/eduLearning";
import CodeTreeSelector from "@/components/selectors/codeTreeSelector";
import EduSorter from "@/components/educations/eduSorter";
import Swiper from "../../../public/ssflex/assets/js/swiper.min";

export default {
	name: "appEducations",
	components: {EduSorter, CodeTreeSelector, EduLearning, EduList},
	props: {
		cateCode: String,
		cateName: String,
	},
	data() {

		/**
		 * mode : list, learn
		 * @type {string|string}
		 */
		var mode = this.webUtils.getParameter("mode")
		mode = (mode === '') ? "list" : mode;

		/**
		 * emIdx
		 * @type {number|string|string}
		 */
		var emIdx = this.webUtils.getParameterInt("emIdx");
		emIdx = ( emIdx > 0 ) ? emIdx : 0;

		var params = new this.pageUtils.Params();
		params.size = 8;

		/**
		 * cateCode : params 우선, query 후순위
		 */
		if ( !this.stringUtils.isEmpty( this.$route.params.cateCode ) ) {
			params.cateCode = this.$route.params.cateCode
		} else {
			params.cateCode = this.$route.query.cateCode
		}

		if ( this.stringUtils.isEmpty(params.cateCode) ) {
			params.cateCode = "2001"
		}

		return {
			mode,
			emIdx,
			cateCodeVO: {},
			coAccountVO: {},
			titleCodeVO: {},

			params,

			eduList: [],
			eduCount: 0,
			rateCode: 0,
		}
	},
	beforeCreate() {
	},
	created() {
		this.$eventBus.$on("goLearning", (_emIdx) => {
			this.goLearning( _emIdx );
		});

		if (location.hash) {
			let hash = location.hash.replace("#", "")
			if (hash !== 'loadMore') {
				this.webUtils.scroll(this, '#item-' + hash)
			}
		}
	},
	async mounted() {

		this.titleCodeVO = await this.getCodeOne( this.params.cateCode )

		this.getMainList();

		$(".list-controls .tab").each(function () {
			var tabnav = new Swiper($(this), {
				slidesPerView: "auto",
				spaceBetween: 24,
				freeMode: true,
				breakpoints: {
					767: {
						spaceBetween: 16,
					},
				},
			});
		});

	},
	methods: {


		getMainList () {
			this.coAccountVO = this.getSessionProc();

			var temp = this.params
			if ( !this.stringUtils.isEmpty( this.$route.query.cateCode ) ) {
				temp.cateCode = this.$route.query.cateCode;
			}

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get( this, this.APIs.EDU_MAIN + "/", temp, (res) => {
				this.$eventBus.$emit("doneProgress", 1)

				const result = res.data
				if ( result.status === "ok" ) {

					console.log( result )
					// this.eduList.push(...result.list)
					this.eduList = result.list
					this.eduCount = result.count

					if (location.hash) {
						let hash = location.hash.replace("#", "")
						if (hash === 'loadMore') {
							this.webUtils.scroll(
								this
								, '#item-' + this.eduList[(this.params.size) * (this.params.page * 1) - 1].emIdx
								, {
									behavior: "smooth"
									, block: "center"
								}
								, () => this.webUtils.removeHash()
								, () => {
									document.querySelector('.learning').scrollIntoView({
										behavior: "smooth"
										, block: "end"
									})
									this.webUtils.removeHash()
								}
								, 1000
							)
						}
					}
				} else {
					console.log( result.msg )
				}

			})

		},


		doLoadMore() {

			this.params.page++;
			this.params.hash = 'loadMore'

			this.webUtils.goTo(this, this.params)
			// this.pageUtils.routerPush( this, this.params )
			// this.getMainList();
		},


		setCateCode( _cateCode ) {

			// 빈코드가 올 경우 기본 코드 전송
			if ( _cateCode == null || _cateCode === "" ) {
				_cateCode = this.cateCode
			}

			this.params.page = 0
			this.params.cateCode = _cateCode;
			this.params.searchText = "";

			this.pageUtils.routerPush( this, this.params )
			// this.getMainList();
		},


		doSearch(e) {

			e.preventDefault()

			this.params.page = 0
			//this.params.cateCode = "";

			this.pageUtils.routerPush( this, this.params )
			// this.getMainList();
		},



		doSort ( _sort ) {
			this.params.sort = _sort;
			this.pageUtils.routerPush( this, this.params )
			// this.getMainList();
		},



		goLearning(_emIdx) {

			this.mode = "learn"
			this.emIdx = _emIdx
			var temp = {
				mode: this.mode,
				emIdx: _emIdx,
				page: this.params.page,
				sort: this.params.sort,
				searchText: this.params.searchText
			}
			// this.pageUtils.routerPush(this, temp);
			this.webUtils.goTo(this, temp, true, false, () => {
				this.webUtils.scrollTo('.content');
			})
		},

		goList() {
			this.webUtils.goTo(this, { page: this.params.page, sort: this.params.sort, searchText: this.params.searchText, hash: this.webUtils.getParameter("emIdx") })
		}

	},
}
</script>

<style scoped>

</style>
